import React, { useContext, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { LoginContext } from "helpers/LoginContext";
import SideBar from "../../../components/common/SideBar/SideBarNew";
import RolespermissionsList from "./RolesPermissionsList";
import Header from "components/common/Header/Header";
import PlanUpgradeGate from "components/common/PlanUpgradeGate/PlanUpgradeGate";
import { BiPlus } from "react-icons/bi";
import RoleAndPermissionModal from "./RoleAndPermissionModal.jsx/RoleAndPermissionModal";
import { portalTypeOptions } from "Constants/constant";
import {
  getPlanFeatureUpgradeMessage,
  resolveRolePlanFeature,
} from "helpers/planFeatures";
import { getUser } from "store/selector/auth.selector";

const RolesAndPermissionSetting = (props) => {
  const {
    roleAndPermisisonCreateOrUpdateRequest,
    roleAndPermissionsCreateOrUpdateLoader,
    roleAndPermissionsList,
    rolesAndPermissionslistRequest,
    defaultRoleAndPerLoader,
    defaultRoleAndPermissions,
    defaultRolesAndPermissionsRequest,
    listingRoleAndPerLoader,
    resetDefaultRolesPermissionLocally,
  } = props;

  const { sideBarPadding, isUserGracePeriodOver } = useContext(LoginContext);
  const currentUser = useSelector(getUser);

  const [isOpenModal, setIsOpenModal] = useState(false);
  const [selectedPermissionUUID, setSelectedPermissionUUID] = useState(null);
  const [selectedPortalFilter, setSelectedPortalFilter] = useState(
    portalTypeOptions[0]
  );

  const roleFeature = useMemo(
    () =>
      resolveRolePlanFeature(
        currentUser,
        selectedPortalFilter?.value,
        roleAndPermissionsList
      ),
    [currentUser, selectedPortalFilter?.value, roleAndPermissionsList]
  );
  const canAddRole = roleFeature?.can_create !== false;
  const roleLimitMessage = useMemo(
    () =>
      getPlanFeatureUpgradeMessage("roles", {
        reason: roleFeature?.reason,
      }),
    [roleFeature?.reason]
  );

  return (
    <>
      <div className='min-h-full'>
        <SideBar />
        <div
          className={`${
            sideBarPadding
              ? "lg:pl-[4rem] duration-300"
              : "lg:pl-64 duration-300"
          }  flex flex-col`}
        >
          <main className='h-screen flex-1 bg-white'>
            <Header
              title='Roles & Permissions'
              btnLabel='Add New Role'
              icon={<BiPlus />}
              handleClick={() => {
                if (canAddRole && !isUserGracePeriodOver) {
                  setIsOpenModal(true);
                }
              }}
              isButton
              isButtonDisabled={!canAddRole || isUserGracePeriodOver}
            />
            {!canAddRole && (
              <div className='mx-6 lg:mx-8 mt-4'>
                <PlanUpgradeGate
                  feature='roles'
                  featureDto={roleFeature}
                  compact
                  message={roleLimitMessage}
                />
              </div>
            )}
            {roleFeature?.limit != null && (
              <p className='mx-6 lg:mx-8 mt-3 text-sm text-gray-600'>
                {selectedPortalFilter?.label} roles:{" "}
                <strong>
                  {roleFeature.current ?? 0} / {roleFeature.limit}
                </strong>
                {roleFeature.current > roleFeature.limit
                  ? " (includes roles above plan limit — upgrade to add more)"
                  : ""}
              </p>
            )}
            <RolespermissionsList
              listingRoleAndPerLoader={listingRoleAndPerLoader}
              rolesAndPermissionslistRequest={rolesAndPermissionslistRequest}
              roleAndPermissionsList={roleAndPermissionsList}
              setSelectedPermissionUUID={setSelectedPermissionUUID}
              setIsOpenModal={setIsOpenModal}
              selectedPortalFilter={selectedPortalFilter}
              setSelectedPortalFilter={setSelectedPortalFilter}
            />
          </main>
        </div>
      </div>
      {isOpenModal && (
        <RoleAndPermissionModal
          isUserGracePeriodOver={isUserGracePeriodOver}
          resetDefaultRolesPermissionLocally={
            resetDefaultRolesPermissionLocally
          }
          defaultRolesAndPermissionsRequest={defaultRolesAndPermissionsRequest}
          defaultRoleAndPerLoader={defaultRoleAndPerLoader}
          defaultRoleAndPermissions={defaultRoleAndPermissions}
          roleAndPermissionsCreateOrUpdateLoader={
            roleAndPermissionsCreateOrUpdateLoader
          }
          roleAndPermisisonCreateOrUpdateRequest={
            roleAndPermisisonCreateOrUpdateRequest
          }
          selectedPermissionUUID={selectedPermissionUUID}
          isOpen={isOpenModal}
          setIsOpenModal={(val) => {
            setIsOpenModal(val);
            setSelectedPermissionUUID(null);
          }}
          selectedPortalFilter={selectedPortalFilter}
        />
      )}
    </>
  );
};

export default RolesAndPermissionSetting;
